import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#f5f0e6] border-y border-[#e2e8f0]" data-id="element-120">
      <div className="container mx-auto px-4 text-center" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-[#e2e8f0]" data-id="element-122">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#fdfbf7] text-[#1a3622] mb-6 border border-[#d4af37]" data-id="element-123">
            <ShieldCheck className="w-10 h-10" data-id="element-124" />
          </div>

          <h2 className="text-3xl font-extrabold text-[#1a3622] mb-4" data-id="element-125">
            🛡️ GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <p className="text-[#5c4033] mb-6 text-left md:text-center" data-id="element-126">
            Abrí los tomos. Revisá los libros de ganadería. Usá los cuadernos de
            actividades con tus alumnos o en tu propio estudio esta semana.
          </p>

          <div className="bg-[#1a3622]/5 text-[#1a3622] font-bold text-lg py-4 px-6 rounded-xl mb-6 border border-[#1a3622]/10 text-left md:text-center" data-id="element-127">
            Si sentís que el material no tiene la profundidad que prometemos, o
            que no te ahorró horas de trabajo: Te devolvemos el 100% de tu
            dinero. Sin preguntas. Sin formularios. Sin vueltas.
          </div>

          <p className="text-[#8b5a2b] font-medium text-sm" data-id="element-128">
            Porque si el pack no te da el valor que prometemos, no queremos
            quedarnos con tu plata.
          </p>
        </motion.div>
      </div>
    </section>;
}